import mainMenuImg from "../../../../assets/main-menu.jpg";
import profileDropdownImg from "../../../../assets/profile-dropdown.jpg";
import selectLanguageImg from "../../../../assets/select-language.jpg";
import homeHeader1Img from "../../../../assets/home-header1.jpg";
import homeHeader2Img from "../../../../assets/home-header2.jpg";
import assignments1Img from "../../../../assets/assignments1.jpg"
import assignments2Img from "../../../../assets/assignments2.jpg"
import filtersImg from "../../../../assets/filters.jpg";
import modalLockedAssignmentImg from "../../../../assets/modalLockedAssignment.jpg";
import loginHeaderImg from "../../../../assets/loginHeader.jpg";
import loginFormImg from "../../../../assets/loginForm.jpg";
import loginMessagesImg from "../../../../assets/loginMessages.jpg";
import loginFooterImg from "../../../../assets/loginFooter.jpg";
import forgotPasswordHeaderImg from "../../../../assets/forgotPasswordHeader.jpg";
import forgotPasswordFormImg from "../../../../assets/forgotPasswordForm.jpg";
import forgotPasswordInfoImg from "../../../../assets/forgotPasswordInfo.jpg";
import forgotPasswordMessagesImg from "../../../../assets/forgotPasswordMessages.jpg";
import setNewPasswordHeaderImg from "../../../../assets/setNewPasswordHeader.jpg";
import setNewPasswordFormImg from "../../../../assets/setNewPasswordForm.jpg";
import passwordResetImg from "../../../../assets/passwordReset.jpg";
import setNewPasswordMessagesImg from "../../../../assets/setNewPasswordMessages.jpg";
import activateAccountFormImg from "../../../../assets/activateAccountForm.jpg";
import courseContentTabImg from "../../../../assets/courseContentTab.jpg";
import notesTab1Img from "../../../../assets/notesTab1.jpg";
import notesTab2Img from "../../../../assets/notesTab2.jpg";
import assignmentHeaderImg from "../../../../assets/assignmentHeader.jpg";
import errorPageMessages1Img from "../../../../assets/errorPageMessages1.jpg";
import errorPageMessages2Img from "../../../../assets/errorPageMessages2.jpg";
import certificatesImg from "../../../../assets/certificates.jpg";
import resetPasswordModalImg from "../../../../assets/resetPasswordModal.jpg";
import myProfile1Img from "../../../../assets/myProfile1.jpg";
import myProfile2Img from "../../../../assets/myProfile2.jpg";
import bannerImg from "../../../../assets/banner.jpg";
import bannerMobile1Img from "../../../../assets/bannerMobile1.jpg";
import bannerMobile2Img from "../../../../assets/bannerMobile2.jpg";
import linkExpiredHeaderImg from "../../../../assets/linkExpiredHeader.jpg";
import linkExpiredFormImg from "../../../../assets/linkExpiredForm.jpg";
import certificateView1Img from "../../../../assets/certificateView1.jpg";
import certificateView2Img from "../../../../assets/certificateView2.jpg";
import profileMessages1Img from "../../../../assets/profileMessages1.jpg";
import profileMessages2Img from "../../../../assets/profileMessages2.jpg";
import profileMessages3Img from "../../../../assets/profileMessages3.jpg";
import modalMaxAttemptsLimitImg from "../../../../assets/modalMaxAttemptsLimit.jpg" 
import acknowledgmentLocked1Img from "../../../../assets/acknowledgmentLocked1.jpg" 
import acknowledgmentLocked2Img from "../../../../assets/acknowledgmentLocked2.jpg" 
import acknowledgmentRequired from "../../../../assets/acknowledgmentRequired.jpg" 
import acknowledgmentRequiredTipico1Img from "../../../../assets/acknowledgmentRequiredTipico1.jpg" 
import acknowledgmentRequiredTipico2Img from "../../../../assets/acknowledgmentRequiredTipico2.jpg" 
import acknowledgmentSubmittedImg from "../../../../assets/acknowledgmentSubmitted.jpg" 
import acknowledgmentNotRequiredImg from "../../../../assets/acknowledgmentNotRequired.jpg" 
import ackONpbpONImg from "../../../../assets/ackONpbpON.jpg"
import ackOFFpbpONImg from "../../../../assets/ackOFFpbpON.jpg"
import { TabId } from "../../../../services/api/types/portalConfiguration/translations";

// The Tipico portal has bespoke acknowledgement copy (see CUSTOM_ACK_TEXT_PORTAL_UID
// in AcknowledgementPanel.tsx) — its reference images/labels are only relevant to
// whoever is translating that portal, so keep them out of everyone else's view.
export const isTipicoContext = (): boolean =>
  typeof window !== "undefined" &&
  window.location.href.toLowerCase().includes("tipico");

const TIPICO_ONLY_IMAGES: string[] = [
  acknowledgmentRequiredTipico1Img,
  acknowledgmentRequiredTipico2Img,
];

export const SECTION_IMAGES: Partial<Record<TabId, Record<string, string[]>>> =
  {
    appFrame: {
      mainMenu: [mainMenuImg],
      navbar: [profileDropdownImg, selectLanguageImg],
    },
    home: {
      header: [homeHeader1Img, homeHeader2Img],
      assignments: [assignments1Img,assignments2Img],
      filters: [filtersImg],
      banner: [bannerImg, bannerMobile1Img, bannerMobile2Img],
      modalLockedAssignment: [modalLockedAssignmentImg],
    },
    login: {
      loginHeader: [loginHeaderImg],
      loginForm: [loginFormImg],
      loginMessages: [loginMessagesImg],
      footer: [loginFooterImg],
    },
    "forgot-password": {
      forgotPasswordHeader: [forgotPasswordHeaderImg],
      forgotPasswordForm: [forgotPasswordFormImg],
      forgotPasswordInfo: [forgotPasswordInfoImg],
      forgotPasswordMessages: [forgotPasswordMessagesImg],
    },
    "new-password": {
      setNewPasswordHeader: [setNewPasswordHeaderImg],
      setNewPasswordForm: [setNewPasswordFormImg],
      passwordReset: [passwordResetImg],
      setNewPasswordMessages: [setNewPasswordMessagesImg],
      activateAccountForm: [activateAccountFormImg],
    },
    "link-expired": {
      linkExpiredHeader: [linkExpiredHeaderImg],
      linkExpiredForm: [linkExpiredFormImg],
    },
    "assignment-detail": {
      courseContentTab: [courseContentTabImg],
      notesTab: [notesTab1Img, notesTab2Img],
      header: [assignmentHeaderImg],
      modalMaxAttemptsLimit: [modalMaxAttemptsLimitImg],
      acknowledgmentLocked:[acknowledgmentLocked1Img,acknowledgmentLocked2Img],
      acknowledgmentRequired: [acknowledgmentRequired,acknowledgmentRequiredTipico1Img,acknowledgmentRequiredTipico2Img],
      acknowledgmentSubmitted: [acknowledgmentSubmittedImg],
      acknowledgmentNotRequired:[acknowledgmentNotRequiredImg],
      acknowledgmentPageByPage: [ackONpbpONImg,ackOFFpbpONImg]
    },
    errorPage: {
      messages: [errorPageMessages1Img, errorPageMessages2Img],
    },
    certificates: {
      page: [certificatesImg],
      certificateView: [certificateView1Img,certificateView2Img]
    },
    "my-profile": {
      page: [myProfile1Img, myProfile2Img],
      resetPasswordModal: [resetPasswordModalImg],
      messages: [profileMessages1Img,profileMessages2Img,profileMessages3Img],
    },
  };

export const getSectionImages = (
  tabId: TabId,
  tabSectionKey: string,
): string[] => {
  const images = SECTION_IMAGES[tabId]?.[tabSectionKey] ?? [];
  if (isTipicoContext()) return images;
  return images.filter((img) => !TIPICO_ONLY_IMAGES.includes(img));
};
